import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icon/google-play.svg")